import { render, staticRenderFns } from "./CardBondType.vue?vue&type=template&id=70b9deb9&"
import script from "./CardBondType.vue?vue&type=script&lang=js&"
export * from "./CardBondType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports